import authService from "@/services/auth";
import router from "../../router/index";


const user = JSON.parse(localStorage.getItem("user"));
const status = user
  ? { status: { loggeduser: true }, user }
  : { status: {}, user: null };

const getDefaultState = () => {
  return {
    status,
    loadingStatus: false,
    userDetails: {},
    userEntities: {},
    currentEntity: {},
    availableEntity: null,
    domains: [
      "app.visipoint.uk",
      "app.visipoint.us",
      "app.visipoint.co",
      "app.visipoint.app",
      "apptest.visipoint.dev",
      "appqa.visipoint.dev",
    ],
    userPassword: null,
    emailDuplicatedCheck: null,
    phoneDuplicatedCheck: null,
    modalState: false,
    verifyPhone: false,
    clientSecret: null,
    loginErrorMassage: null,
    usersPermissions: [],
    userRole: {},
    refreshGridAfterSocket: false,
    loginStatus: false,
    plan: null
  };
};

export const state = getDefaultState();

export const actions = {
  // check duplicated

  checkDuplicated({ dispatch, commit }, params) {
    commit("loadongStatus", true);
    if (params.field == "email") commit("setEmailDuplicatedCheck", null);
    else commit("setPhoneDuplicatedCheck", null);

    return new Promise((resolve, reject) => {
      authService
        .checkDuplicated(params)
        .then((data) => {
          resolve(data);
          console.log("store", data.data.data);
          params.field == "phone"
            ? commit("setPhoneDuplicatedCheck", data.data.data)
            : commit("setEmailDuplicatedCheck", data.data.data);
          if (data.data.data) {
            commit("loadongStatus", false);
          }
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            Object.values(err.response.data.errors).join("\r\n")
          );
          commit("registerFailure", err);
          dispatch("notification/error", err.response.data.errors, {
            root: true,
          });
          commit("loadongStatus", false);
          commit("loginFailure", err);
        });
    });
  },

  checkDuplicatedForConfirm({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      authService
        .checkDuplicated(params)
        .then((data) => {
          resolve(data);
          console.log("store", data.data.data);
          params.field == "phone"
            ? commit("setPhoneDuplicatedCheck", data.data.data)
            : commit("setEmailDuplicatedCheck", data.data.data);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            Object.values(err.response.data.errors).join("\r\n")
          );
          commit("registerFailure", err);
          dispatch("notification/error", err.response.data.errors, {
            root: true,
          });
          commit("loadongStatus", false);
          commit("loginFailure", err);
        });
    });
  },

  // Logs in the user.
  // eslint-disable-next-line no-unused-vars
  login({ dispatch, commit, getters }, data) {
    commit("loadongStatus", true);
    return new Promise((resolve, reject) => {
      authService
        .login(data)
        .then((data) => {
          resolve(data);
          // console.log(data)
          localStorage.setItem("user", JSON.stringify({data:{access_token:data.data.data.token_data.access_token}}) );  
          commit("loginSuccess", data.data.data.token_data.access_token);
          commit("loadongStatus", false);
          commit("setUserRole", data.data.data.role);
          commit("setUsersPermissions", data.data.data.permissions);
          commit("setCurrentPlan", data.data.data.plan);
          dispatch("fetchuserDetails");
          console.log('getters.getEntityByDomain', getters.getEntityByDomain);
          if (getters.getEntityByDomain) {
            commit("currentEntity", getters.getEntityByDomain);
            if (getters.getEntityByDomain.package == "Cloud") {
              router.push("/");
            } else if (getters.getEntityByDomain.package == "Standalone") {
              router.push("/sites");
            }
          }
        })
        .catch((err) => {
          console.log({err})
          reject(err);
          commit("loadongStatus", false);
          commit("loginFailure", err);
          commit("setLoginErrorMassage", err.response.data);
          commit("loadongStatus", false);
          if (err.response.data && err.response.data.message != 'pending') {
            this._vm.$toast.error(err.response.data.message);
          }
        });
    });
  },
  // Logout the user
  logout({ commit }) {
    commit("loadongStatus", true);
    return new Promise((resolve, reject) => {
      authService
        .logout()
        .then((data) => {
          resolve(data);
          commit("logout");
          commit("loadongStatus", false);
          // setTimeout(() => {
            const permenantlyExpanded = localStorage.getItem("permenantlyExpanded");
            localStorage.clear();
            if (permenantlyExpanded)
              localStorage.setItem("permenantlyExpanded", permenantlyExpanded);
          // }, 1000);
          if (window.location.origin == process.env.VUE_APP_DOMAIN) {
            window.location.href = `${process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT}/login`;
          } else {
            window.location.href = `${window.location.origin}/login`;
          }
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message);
          commit("loadongStatus", false);
        });
    });
  },
  // register user
  registeruser({ dispatch, commit }, user) {
    commit("loadongStatus", true);
    commit("loginRequest", user);
    return new Promise((resolve, reject) => {
      authService
        .registerUser(user)
        .then((data) => {
          resolve(data);
          commit("loadongStatus", false);
          dispatch("notification/success", "Registration successful", {
            root: true,
          });
          this._vm.$toast.success("Registration Successful");
          window.location.href = process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT;
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(
            Object.values(err.response.data.errors).join("\r\n")
          );
          commit("registerFailure", err);
          dispatch("notification/error", err.response.data.errors, {
            root: true,
          });
          commit("loadongStatus", false);
          commit("loginFailure", err);
        });
    });
  },
  // get entity by subdomain
  onEntityBySubdomain({ commit }, params) {
    return new Promise((resolve, reject) => {
      authService
        .entityBySubdomain(params)
        .then((data) => {
          commit("setEntityBySubdomain", data.data.data);
          console.log("onEntityBySubdomain", data, window.location.href);
          if (
            !data.data.data &&
            window.location.href != "http://192.168.1.10:8080/login"
          ) {
            window.location.href =
              process.env.VUE_APP_BASE_URL_PASSPORT_REDIRECT;
          }
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  // get passport auth
  onPassportAuth({ dispatch, commit }, params) {
    commit("setLoginLoading",true);
    return new Promise((resolve, reject) => {
      authService
        .passportAuth(params)
        .then((data) => {
          localStorage.setItem("entityId", params.entity_id);
          localStorage.setItem(
            "user",
            JSON.stringify({ data: { access_token: data.data.data.token } })
          );
          commit("loginSuccess", data.data.data.token);
          dispatch("fetchuserDetails");
          commit("loadongStatus", false);
          commit("setPassportAuth", data.data.data.token);
          commit("setUserRole", data.data.data.role);
          commit("setUsersPermissions", data.data.data.permissions);
          commit("setCurrentPlan", data.data.data.plan);
        })
        .catch((err) => {
          reject(err);
        }).finally(()=>{
          commit("setLoginLoading",false);
        });
    });
  },
  updateUserRoleAfterChange({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      authService
        .updateUserRoleAfterChange(params)
        .then((data) => {
          resolve(data);
          localStorage.setItem("entityId", params.entity_id);
          dispatch("fetchuserDetails");
          commit("loadongStatus", false);
          commit("setUserRole", data.data.role);
          commit("setUsersPermissions", data.data.permissions);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // user details
  fetchuserDetails({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      authService
        .userDetails()
        .then(async (data) => {
          resolve(data);
          localStorage.setItem("userDetails", JSON.stringify(data.data));
          commit("userDetails", data.data);
          localStorage.setItem("language", data.data.lang);
          commit("i18N/setLanguage", data.data.lang, { root: true });
          payload
            ? ""
            : dispatch("entity/fetchEntities", data.data.user_id, {
              root: true,
            });
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.response?.data?.message);
        });
    });
  },
  setCurrentEntity({ commit }, entity) {
    commit("currentEntity", entity);
  },
  clearStore({ dispatch }) {
    dispatch("grid/clearAllStoreState", null, { root: true });
  },
  saveKioskPackage({ commit }, payload) {
    commit("setKioskPackage", payload);
  },
  saveUserPassword({ commit }, payload) {
    commit("setUserPassword", payload);
  },
  fetchSocketDataToRefreshGrid({ commit }, payload) {
    // console.log('payloaddddd',payload);
    commit("setSocketDataToRefreshGrid", payload);
  },
  // reset
  resetLoading({ commit }) {
    commit("loadongStatus", false);
    commit("entity/setSubdomain", null, { root: true });
  },
  fetchClientSecret({ commit }) {
    const integrationKEY = process.env.VUE_APP_INTEGRATION_KEY;
    return new Promise((resolve, reject) => {
      authService.getClientSecret({ key: integrationKEY }).then(async (data) => {
        resolve(data);
        commit("setClientSecret", data.data.data)
        // await dispatch("fetchInterationToken", data.data.data);
      })
        .catch((err) => {
          reject(err)
          this._vm.$toast.error(err.response.data.message);
        });
    });
  },
  fetchInterationToken({ state }) {
    // console.log(state.clientSecret)
    const tokenTime = new Date();
    return new Promise((resolve, reject) => {
      authService.getIntegrationToken({ secret: state.clientSecret }).then((data) => {
        console.log(data, tokenTime, JSON.stringify(tokenTime));
        resolve(data);
        localStorage.setItem("Integration_Token", JSON.stringify(data.data.data.access_token));
        localStorage.setItem("Integration_Token_Time", JSON.stringify(tokenTime));
      })
        .catch((err) => {
          reject(err)
          this._vm.$toast.error(err.response.data.message);
        });
    });
  },
  fetchPassportToken() {
    // console.log(state.clientSecret)
    return new Promise((resolve, reject) => {
      authService.getPassportToken().then((data) => {
        resolve(data);
        localStorage.setItem("passport_token", data.data.data);
      })
        .catch((err) => {
          reject(err)
          this._vm.$toast.error(err.response.data.message);
        });
    });
  },
  updateEntityPackage({ commit },payload){
    commit("updateEntityPackage", payload);
  },
  updateEntityPlan({ commit }, payload) {
   // Work with a lowercase copy of payload to avoid modifying the original
  const packagePlan = payload.toLowerCase();

  let planId = null;

  // Switch statement for mapping package plans to IDs
  switch (packagePlan) {
    case "lite":
      planId = 1;
      break;
    case "professional":
      planId = 2;
      break;
    case "enterprise":
      planId = 3;
      break;
    default:
      console.error(`Unknown package plan: ${packagePlan}`);
      return null;
    }

    commit("setCurrentPlan", planId);
  },
};

export const mutations = {
  setEmailDuplicatedCheck(state, payload) {
    state.emailDuplicatedCheck = payload;
  },
  setPhoneDuplicatedCheck(state, payload) {
    state.phoneDuplicatedCheck = payload;
  },

  resetAuthenticationState(state) {
    // Merge rather than replace so we don't lose observers
    Object.assign(state, getDefaultState());
  },
  loadongStatus(state, loading) {
    state.loadingStatus = loading;
  },
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggeduser: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.userEntities = {};
    state.userDetails = {};
    setTimeout(() => {
      state.currentEntity = {};
    }, 1000);
    state.user = null;
  },
  // user details
  userDetails(state, user) {
    state.userDetails = user;
  },
  // user entities
  userEntities(state, entities) {
    state.userEntities = entities;
  },
  // current entity
  currentEntity(state, entity) {
    state.currentEntity = entity;
  },
  setKioskPackage(state, payload) {
    state.kioskPackage = payload;
  },
  setKioskData(state, payload) {
    state.kioskData = payload;
  },
  setEntityBySubdomain(state, payload) {
    state.availableEntity = payload;
  },
  setPassportAuth(state, payload) {
    state.status = { loggeduser: true };
    state.passport = payload;
  },
  setUserPassword(state, payload) {
    state.userPassword = payload;
  },
  setClientSecret(state, payload) {
    state.clientSecret = payload;
  },
  setLoginErrorMassage(state, payload) {
    state.loginErrorMassage = payload;
  },
  setPassportToken(state, payload) {
    state.clientSecret = payload;
  },
  setUserRole(state, payload) {
    state.userRole = payload;
  },
  setUsersPermissions(state, payload) {
    state.usersPermissions = payload;
  },
  setCurrentPlan(state, payload){
    state.plan = payload
  },
  setSocketDataToRefreshGrid(state, payload) {
    state.refreshGridAfterSocket = payload;
  },
  setLoginLoading(state,payload){
    state.loginStatus = payload
  },
  updateEntityPackage(state,payload){
    if(state.currentEntity)
      state.currentEntity.package = payload
  },
};

export const getters = {
  getEmailDuplicatedCheck(state) {
    return state.emailDuplicatedCheck;
  },
  getPhoneDuplicatedCheck(state) {
    return state.phoneDuplicatedCheck;
  },
  
  loadingStatus(state) {
    return state.loadingStatus;
  },
  userDetails(state) {
    return state.userDetails;
  },
  userEntities(state) {
    return state.userEntities;
  },
  currentEntity(state) {
    return state.currentEntity;
  },
  getKioskPackage(state) {
    return state.kioskPackage;
  },
  getKioskData(state) {
    return state.kioskData;
  },
  getEntityByDomain(state) {
    return state.availableEntity;
  },
  getPassportAuth(state) {
    return state.passport;
  },
  getUserPassword(state) {
    return state.userPassword;
  },
  getClientSecret(state) {
    return state.clientSecret;
  },
  getLoginErrorMassage(state) {
    return state.loginErrorMassage;
  },
  getPassportToken(state) {
    return state.clientSecret;
  },
  getUserRole(state){
    return state.userRole
  },
  getUserPermissions(state){
    return state.usersPermissions
  },
  getSocketDataToRefreshGrid(state){
    return state.refreshGridAfterSocket
  },
  getLoginLoading(state){
    return state.loginStatus
  },
  getCurrentPlan(state){
    return state.plan
  }
};
